export default __webpack_public_path__ + "static/media/loaf-mouse-1.15454a92.svg";